import { render } from "./Activity.vue?vue&type=template&id=41182dd4&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"

import "./Activity.vue?vue&type=style&index=0&id=41182dd4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-41182dd4"

export default script